// import React, { useContext } from "react";
// import { Route as RouterRoute, Redirect } from "react-router-dom";

// import { AuthContext } from "../context/Auth/AuthContext";
// import BackdropLoading from "../components/BackdropLoading";

// const Route = ({ component: Component, isPrivate = false, ...rest }) => {
// 	const { isAuth, loading } = useContext(AuthContext);

// 	if (!isAuth && isPrivate) {
// 		return (
// 			<>
// 				{loading && <BackdropLoading />}
// 				<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
// 			</>
// 		);
// 	}

// 	if (isAuth && !isPrivate) {
// 		return (
// 			<>
// 				{loading && <BackdropLoading />}
// 				<Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
// 			</>
// 		);
// 	}

// 	return (
// 		<>
// 			{loading && <BackdropLoading />}
// 			<RouterRoute {...rest} component={Component} />
// 		</>
// 	);
// };

// export default Route;


import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading } = useContext(AuthContext);

	// Aguarda autenticação carregar antes de qualquer render
	if (loading) {
		return <BackdropLoading />;
	}

	// 🔐 Se a rota é privada e o usuário não está autenticado, redireciona para login
	if (isPrivate && !isAuth) {
		return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
	}

	// 🔓 Se for rota pública (isPrivate false), ou rota privada com auth ok → renderiza normalmente
	return <RouterRoute {...rest} component={Component} />;
};

export default Route;
